<template>
    <!-- FAQ Section -->
    <div class="py-12 md:py-20 px-4 md:px-8">
        <div class="max-w-3xl mx-auto">
            <h2
                class="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 text-center font-medium"
            >
                Common questions about
                <span class="text-orange">10xTravel+</span>
            </h2>

            <div class="mt-8 flex flex-col divide-y divide-slate-200 dark:divide-slate-700">
                <div v-for="(faq, index) in faqs" :key="index" class="py-4">
                    <button
                        class="w-full flex items-center justify-between text-left rounded"
                        @click="toggleFaq(index)"
                    >
                        <span
                            class="text-base font-medium text-slate-800 dark:text-slate-100 pr-4"
                        >
                            {{ faq.question }}
                        </span>
                        <Icon
                            :icon="openFaq === index ? 'minus' : 'plus'"
                            class="w-5 h-5 text-slate-800 dark:text-slate-100 shrink-0"
                        />
                    </button>
                    <div
                        v-show="openFaq === index"
                        class="mt-3 text-sm text-slate-500 dark:text-slate-400 leading-relaxed pr-8"
                    >
                        {{ faq.answer }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const openFaq = ref(null);

const faqs = [
    {
        question: 'How quickly will the membership pay for itself?',
        answer: "For most members, within the first month. The average credit card with an annual fee includes $50-$200+ in monthly and annual credits. If you're not actively tracking them, you're likely missing at least $10 worth every month; and often much more. The benefit tracker typically surfaces forgotten credits in the first use. And a single award alert, once booked, can be worth hundreds or even thousands of dollars in travel savings.",
    },
    {
        question: 'How does the benefits tracker work with my credit cards?',
        answer: "Once you add your cards to your My10x wallet, the benefit tracker pulls in all the credits and perks associated with each card - monthly dining credits, annual travel credits, streaming credits, and more. You'll see a clear dashboard of what's available, what's been used, and what's about to expire. You can track unlimited cards as a 10xTravel+ member (free users are limited to 1 card).",
    },
    {
        question: 'How often are award alerts sent?',
        answer: '10xTravel+ members receive alerts at a higher frequency than our free tier. We send daily summaries of a wide selection of award availability, high-value alerts as they become available, and even weekly roundups featuring popular destinations.',
    },
    {
        question: 'Can I cancel anytime?',
        answer: "Yes. Cancel anytime from your account settings. If you're within your first 14 days, you can request a full refund. We think you'll love it, but we've made it easy to leave if you don't.",
    },
    {
        question: 'What if I already have a rewards strategy?',
        answer: "Great - 10xTravel+ makes your existing strategy even better. The Best Cards by Category tool is personalized to your exact wallet, so even experienced points collectors find new optimizations. And the Award Alerts surface opportunities you'd have to monitor dozens of sources to find on your own.",
    },
    {
        question:
            "What's the difference between the free My10x tools and 10xTravel+?",
        answer: 'Free My10x users can track 1 card in the Credit and Benefit Maximizer and access the standard Redemption Tracker. 10xTravel+ unlocks unlimited card tracking, the email import feature for the Redemption Tracker, higher-frequency Award Alerts, the Best Cards by Category tool, and access to the private 10xTravel+ community with expert support.',
    },
];

const toggleFaq = (index) => {
    openFaq.value = openFaq.value === index ? null : index;
};
</script>
